import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import WeCraft from "./WeCraft/WeCraft";
import Product from "./ProductDevelopment/Product";
import Ourteam from "./OurTeam/Ourteam";
import OurHistory from "./OurHistory/OurHistory";
import Difference from "./Difference/Difference";
import Shallwetalk from "./Shallwetalk/Shallwetalk";

gsap.registerPlugin(ScrollTrigger);

const CompanyOverview = () => {
  const historyRef = useRef(null);
  const [visibleSection, setVisibleSection] = useState(0);

  useEffect(() => {
    if (!historyRef.current) return;

    gsap.to(historyRef.current, {
      scrollTrigger: {
        trigger: historyRef.current,
        start: "top center",
        end: "bottom center",
        scrub: 1,
      },
    });

    ScrollTrigger.create({
      trigger: historyRef.current,
      start: "top center",
      end: "bottom center",
      onUpdate: (self) => {
        const progress = self.progress;
        if (progress < 0.33) {
          setVisibleSection(0);
        } else if (progress < 0.66) {
          setVisibleSection(1);
        } else {
          setVisibleSection(2);
        }
      },
    });
  }, []);

  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  return (
    <>
      <Header />
      <WeCraft />
      <Product />
      <Ourteam />
      <OurHistory historyRef={historyRef} visibleSection={visibleSection} />
      <Difference />
      <Shallwetalk />
      <Footer />
    </>
  );
};

export default CompanyOverview;
